import type { FieldErrors, FieldValues } from 'react-hook-form';

export function findFirstErrorMessage<T extends FieldValues>(
  errors: FieldErrors<T>,
): string | undefined {
  for (const value of Object.values(errors)) {
    if (!value) continue;
    if (typeof value === 'object' && 'message' in value && typeof value.message === 'string') {
      return value.message;
    }
    if (typeof value === 'object') {
      const nested = findFirstErrorMessage(value as FieldErrors<T>);
      if (nested) return nested;
    }
  }
  return undefined;
}
